






import Vue from 'vue';
import { prefersReducedMotion } from '@/util/motion';

export default Vue.extend({
    name: 'DvStagger',
    props: {
        tag: { type: String, default: 'div' },
        stagger: { type: Number, default: 22 },
        duration: { type: Number, default: 200 },
        //  Cap the per-item delay so a large batch (e.g. a full cash-shop page)
        //  doesn't drag on for seconds; late items past the cap reveal together.
        maxDelay: { type: Number, default: 300 },
    },
    created() {
        //  Non-reactive per-flush counter: mutating it must not trigger renders.
        (this as any)._batch = 0;
    },
    methods: {
        beforeEnter(el: HTMLElement) {
            if (prefersReducedMotion()) return;
            el.style.opacity = '0';
        },
        enter(el: HTMLElement, done: () => void) {
            if (prefersReducedMotion()) { done(); return; }
            const i = (this as any)._batch++;
            //  Reset the counter after this frame so each append batch (e.g. an
            //  infinite-scroll page) restarts its stagger from zero.
            if (i === 0) {
                requestAnimationFrame(() => { (this as any)._batch = 0; });
            }
            (this as any).$anime({
                targets: el,
                opacity: [0, 1],
                translateY: [8, 0],
                delay: Math.min(i * this.stagger, this.maxDelay),
                duration: this.duration,
                easing: 'easeOutCubic',
                complete: () => {
                    el.style.opacity = '';
                    el.style.transform = '';
                    done();
                },
            });
        },
    },
});
